import i18n from 'i18next';

export const FILL_TYPE_OPTIONS: Array<{ value: 'solid' | 'gradient'; label: string }> = [
    { value: 'solid', label: i18n.t('Solid') },
    { value: 'gradient', label: i18n.t('Gradient') },
];
